import styled from 'styled-components'

export const PageWrapper = styled.div`
  min-height: 100vh;
  background: #f5f5f0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 16px 48px;
`

/* Used for loading / error / success states (small centered card) */
export const CenteredCard = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 40px 32px;
  width: 100%;
  max-width: 480px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`

/* Legacy alias so existing references compile */
export const Card = CenteredCard

/* Main layout wrapper for the payment page */
export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const LogoCentered = styled.img`
  height: 40px;
  object-fit: contain;
  align-self: center;
`

export const Logo = styled.img`
  height: 40px;
  object-fit: contain;
`

export const SummaryCard = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 24px 28px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
`

export const PaymentCard = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 24px 28px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
`

export const CardLabel = styled.p`
  font-size: 13px;
  font-weight: 700;
  color: #2d6a4f;
  margin-bottom: 8px;
`

export const StatusIcon = styled.div`
  font-size: 48px;
  line-height: 1;
`

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
  margin: 0;
`

export const Subtitle = styled.p`
  font-size: 14px;
  color: #666;
  text-align: center;
  margin: 0;
`

export const LoadingText = styled.p`
  font-size: 16px;
  color: #888;
`

export const OrderInfo = styled.div`
  width: 100%;
  background: #f9f9f6;
  border-radius: 12px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const OrderTitle = styled.h3`
  font-size: 15px;
  font-weight: 700;
  color: #2d6a4f;
  margin: 0 0 4px;
`

export const OrderDetail = styled.p`
  font-size: 13px;
  color: #555;
  margin: 0;
`

export const OrderDescription = styled.p`
  font-size: 13px;
  line-height: 1.5;
  color: #555;
  margin: 0 0 16px;
`

export const AmountBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid #e8e8e8;

  span {
    font-size: 14px;
    color: #555;
  }

  strong {
    font-size: 20px;
    color: #2d6a4f;
    font-weight: 700;
  }
`

export const MethodTabs = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
`

export const MethodTab = styled.button<{ active: boolean }>`
  flex: 1;
  padding: 10px;
  border-radius: 8px;
  border: 2px solid ${({ active }) => (active ? '#2d6a4f' : '#e0e0e0')};
  background: ${({ active }) => (active ? '#edf7f2' : '#fff')};
  color: ${({ active }) => (active ? '#2d6a4f' : '#888')};
  font-size: 14px;
  font-weight: ${({ active }) => (active ? '700' : '400')};
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #2d6a4f;
    color: #2d6a4f;
  }
`

export const PixInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px;
  background: #f9f9f6;
  border-radius: 12px;
  text-align: center;

  p {
    font-size: 13px;
    color: #666;
    margin: 0;
  }
`

export const PixIcon = styled.div`
  font-size: 32px;
`

export const PixSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`

export const SectionTitle = styled.h4`
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
`

export const QrCodeImage = styled.img`
  width: 200px;
  height: 200px;
  border-radius: 8px;
`

export const CopySection = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  align-items: center;
`

export const PixCode = styled.div`
  flex: 1;
  font-size: 11px;
  color: #555;
  background: #f5f5f5;
  border-radius: 6px;
  padding: 8px 10px;
  word-break: break-all;
  max-height: 60px;
  overflow: hidden;
`

export const CopyButton = styled.button`
  padding: 8px 14px;
  background: #2d6a4f;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover {
    background: #245c43;
  }
`

export const PixNote = styled.p`
  font-size: 13px;
  color: #888;
  text-align: center;
  margin: 0;
`

export const ItemsList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const ItemRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f9f9f6;
  border-radius: 10px;
  padding: 10px 12px;
`

export const ItemPhoto = styled.img`
  width: 52px;
  height: 52px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
  background: #eee;
`

export const ItemPhotoPlaceholder = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 8px;
  background: #e0e0e0;
  flex-shrink: 0;
`

export const ItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
`

export const ItemName = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ItemQty = styled.span`
  font-size: 12px;
  color: #888;
`

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: #2d6a4f;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  align-self: flex-start;

  &:hover {
    text-decoration: underline;
  }
`

export const PayButton = styled.button`
  width: 100%;
  padding: 14px;
  background: #2d6a4f;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s;

  &:hover:not(:disabled) {
    background: #245c43;
  }

  &:disabled {
    background: #a0c4b5;
    cursor: not-allowed;
  }
`
